"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("@lsg/components");

var Headline_1 = require("@lsg/components/lib/components/atoms/Headline/Headline");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var react_components_1 = require("@lws/react-components");

exports.QuoteComponent = function (_a) {
  var data = _a.data;
  var quote = data.longText('quoteText', '');
  var author = data.text('author', '');
  var authorPosition = data.text('authorPosition', '');
  var authorImage = data.asset('authorImage');
  var theme = data["boolean"]('darkTheme') ? components_1.Themes.DARK : components_1.Themes.LIGHT;
  return react_1["default"].createElement(components_1.Theme, {
    look: theme
  }, react_1["default"].createElement(GridRow_1.GridRow, {
    verticalAlign: components_1.Grid.VerticalAlign && components_1.Grid.VerticalAlign.TOP,
    columnVariate: true,
    gap: components_1.Grid.Spacing && components_1.Grid.Spacing.HALF_SECTION
  }, react_1["default"].createElement(GridColumn_1.GridColumn, {
    size: 2,
    sm: 8,
    xs: 0
  }), react_1["default"].createElement(GridColumn_1.GridColumn, {
    size: 9,
    sm: 8,
    xs: 4
  }, react_1["default"].createElement(Quote, null, react_1["default"].createElement(components_1.H3, {
    variant: Headline_1.Variants.THIN
  }, react_1["default"].createElement(react_components_1.MarkdownRenderer, {
    content: quote
  })), react_1["default"].createElement(react_components_1.Person, {
    name: author,
    position: authorPosition,
    avatar: authorImage
  }))), react_1["default"].createElement(GridColumn_1.GridColumn, {
    size: 1,
    sm: 8,
    xs: 0
  })));
};

var Quote = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 24px 0;\n  padding: 0;\n  padding-left: 60px;\n  overflow: hidden;\n\n  h3,\n  ", " {\n    position: relative;\n    margin: 0;\n\n    &::before {\n      position: absolute;\n      left: -25px;\n      background-color: #ffcc00;\n      width: 1px;\n      top: 0;\n      bottom: 0;\n    }\n\n    & p {\n      margin: 0;\n    }\n  }\n\n  h3 {\n    padding-top: 5px;\n    padding-bottom: 16px;\n\n    &::before {\n      content: '';\n    }\n  }\n\n  ", " {\n    padding-bottom: 5px;\n    padding-top: 24px;\n  }\n\n  @media (min-width: 1024px) {\n    h3,\n    ", " {\n      position: relative;\n      margin: 0;\n\n      &::before {\n        content: '';\n        left: -50px;\n        width: 3px;\n      }\n    }\n\n    h3 {\n      padding-bottom: 24px;\n    }\n\n    ", " {\n      padding-top: 0;\n    }\n  }\n"], ["\n  margin: 24px 0;\n  padding: 0;\n  padding-left: 60px;\n  overflow: hidden;\n\n  h3,\n  ", " {\n    position: relative;\n    margin: 0;\n\n    &::before {\n      position: absolute;\n      left: -25px;\n      background-color: #ffcc00;\n      width: 1px;\n      top: 0;\n      bottom: 0;\n    }\n\n    & p {\n      margin: 0;\n    }\n  }\n\n  h3 {\n    padding-top: 5px;\n    padding-bottom: 16px;\n\n    &::before {\n      content: '';\n    }\n  }\n\n  ", " {\n    padding-bottom: 5px;\n    padding-top: 24px;\n  }\n\n  @media (min-width: 1024px) {\n    h3,\n    ", " {\n      position: relative;\n      margin: 0;\n\n      &::before {\n        content: '';\n        left: -50px;\n        width: 3px;\n      }\n    }\n\n    h3 {\n      padding-bottom: 24px;\n    }\n\n    ", " {\n      padding-top: 0;\n    }\n  }\n"])), react_components_1.PersonWrapper, react_components_1.PersonWrapper, react_components_1.PersonWrapper, react_components_1.PersonWrapper);
var templateObject_1;